import { jsx as _jsx } from "react/jsx-runtime";
import Avatar from "@mui/material/Avatar";
import { Icon } from "../../ui-components";
import { IconAvatarStyles } from "./IconAvatar.styles";
export var IconAvatar = function (_a) {
    var icon = _a.icon, variant = _a.variant;
    var sx = IconAvatarStyles(variant);
    return (_jsx(Avatar, { variant: "rounded", sx: sx.wrapper, children: _jsx(Icon, { path: icon, width: "12px", height: "12px" }) }));
};
